<template>
  <div class="light-green accent-4">
    <v-card-actions @click="toggle">
      <span>
        {{ title }}
        <span v-if="value">: {{ value }}</span>
      </span>

      <v-spacer />

      <v-icon>
        {{ modelValue ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="modelValue">
        <v-divider />
        <div class="pa-2">
          <slot />
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: String,
    modelValue: Boolean
  },

  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue)
    }
  }
}
</script>